export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_PROJECT_DISPLAY = "MMM YYYY";
